import { render, staticRenderFns } from "./HonorProgressBar.vue?vue&type=template&id=656339f8&scoped=true&"
import script from "./HonorProgressBar.vue?vue&type=script&lang=js&"
export * from "./HonorProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./HonorProgressBar.vue?vue&type=style&index=0&id=656339f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656339f8",
  null
  
)

export default component.exports